import { getHiddenDataBoolean } from '../../../domain/hidden-data-provider';
import ReactDOM from 'react-dom';
import React from 'react';

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-4440
 */
export const initFooterGDPR = () => {

    const $placeholder = document.getElementById('footer-gdpr-link-ph');
    if(!$placeholder) return;

    const shouldBeShown = getHiddenDataBoolean('gdpr-do-not-sell-link');
    if(!shouldBeShown) return;

    ReactDOM.render(
        <React.StrictMode>
            <p>
                <a
                    className="text-gray-400 underline"
                    href="/legal/cookie-policy">Do Not Sell or Share My Personal Information</a>
            </p>
        </React.StrictMode>,
        $placeholder
    );
};
